import {NgModule,Directive,ElementRef,HostListener,Input,DoCheck} from '@angular/core';
import {CommonModule} from '@angular/common';
export class InputText implements DoCheck {

    filled: boolean;
/**
 * @param {?} el
 */
constructor(public el: ElementRef) {}
/**
 * @return {?}
 */
ngDoCheck() {
        this.updateFilledState();
    }
/**
 * @param {?} e
 * @return {?}
 */
onInput(e) {
        this.updateFilledState();
    }
/**
 * @return {?}
 */
updateFilledState() {
        this.filled = this.el.nativeElement.value && this.el.nativeElement.value.length;
    }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
    selector: '[pInputText]',
    host: {
        '[class.ui-inputtext]': 'true',
        '[class.ui-corner-all]': 'true',
        '[class.ui-state-default]': 'true',
        '[class.ui-widget]': 'true',
        '[class.ui-state-filled]': 'filled'
    }
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'onInput': [{ type: HostListener, args: ['input', ['$event'], ] },],
};
}

function InputText_tsickle_Closure_declarations() {
/** @type {?} */
InputText.decorators;
/**
 * @nocollapse
 * @type {?}
 */
InputText.ctorParameters;
/** @type {?} */
InputText.propDecorators;
/** @type {?} */
InputText.prototype.filled;
/** @type {?} */
InputText.prototype.el;
}

export class InputTextModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule],
    exports: [InputText],
    declarations: [InputText]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function InputTextModule_tsickle_Closure_declarations() {
/** @type {?} */
InputTextModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
InputTextModule.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
